import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "42",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "21",
  cy: "21",
  r: "20.125",
  fill: "#900666",
  stroke: "#fff",
  "stroke-width": "1.75"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M27.13 12h-7.738a3.873 3.873 0 0 0-3.869 3.869v10.06c.004.98.623 1.852 1.548 2.178v.916a1.55 1.55 0 0 0 1.548 1.548h1.547a1.55 1.55 0 0 0 1.548-1.548v-.773h3.095v.773a1.55 1.55 0 0 0 1.548 1.548h1.547a1.55 1.55 0 0 0 1.548-1.548v-.916a2.32 2.32 0 0 0 1.547-2.179v-10.06A3.873 3.873 0 0 0 27.131 12m-7.738 1.548h7.738c.98.003 1.853.622 2.179 1.547H17.214a2.32 2.32 0 0 1 2.178-1.547m.774 15.475H18.62v-.773h1.547zm7.738 0h-1.547v-.773h1.547zm1.548-3.095a.774.774 0 0 1-.774.774H17.845a.774.774 0 0 1-.774-.774v-2.321h12.38zm0-3.869H17.07v-5.416h12.38zM11.655 12a2.316 2.316 0 0 0-.774 4.5v13.297a.775.775 0 0 0 1.547 0V16.5a2.316 2.316 0 0 0-.773-4.5m0 3.095a.772.772 0 0 1-.547-1.32.773.773 0 1 1 .547 1.32"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M20.167 25.154c0 1.032-1.548 1.032-1.548 0 0-1.031 1.548-1.031 1.548 0M27.905 25.154c0 1.032-1.548 1.032-1.548 0 0-1.031 1.548-1.031 1.548 0"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }